import script from "./Certificates.vue?vue&type=script&setup=true&lang=js"
export * from "./Certificates.vue?vue&type=script&setup=true&lang=js"

import "./Certificates.vue?vue&type=style&index=0&id=643bb01d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-643bb01d"]])

export default __exports__